import PropTypes from "prop-types";
import { Box } from "@mui/material";

const BG = "rgba(120,120,120,0.9)";

// Round back button at the top left of the scan view.
// May be used either to abort an ongoing scanning
// or to transition back to the dashboard if applicable.
export const BackButton = (props) => {
  const { onClick, icon = "back" } = props;
  const isClose = icon === "close";
  return (
    <Box
      component="button"
      type="button"
      aria-label={isClose ? "Close" : "Back"}
      onClick={onClick}
      sx={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "none",
        p: 0,
        cursor: "pointer",
        backgroundColor: BG,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* chevron-left icon */}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {isClose ? (
          // X mark
          <path d="M6.5 6.5 L17.5 17.5 M17.5 6.5 L6.5 17.5" />
        ) : (
          // Chevron-left
          <path d="M14.5 6 L8.5 12 L14.5 18" />
        )}
      </svg>
    </Box>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOf(["back", "close"]),
};
